'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _bluebird = require('bluebird');

// Limit the maximum number of ongoing promises returned by fn to LIMIT and
// use a FIFO queue to handle the backlog.
var limitConcurrency = function () {
    var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fn) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(ongoingRequestCount >= LIMIT)) {
                            _context.next = 3;
                            break;
                        }

                        _context.next = 3;
                        return (0, _bluebird.resolve)(new _promise2.default(function (resolve, reject) {
                            backlogQueue.push(resolve);
                        }));

                    case 3:

                        ongoingRequestCount++;
                        _context.prev = 4;
                        _context.next = 7;
                        return (0, _bluebird.resolve)(fn());

                    case 7:
                        return _context.abrupt('return', _context.sent);

                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context['catch'](4);
                        throw _context.t0;

                    case 13:
                        _context.prev = 13;

                        ongoingRequestCount--;
                        checkBacklog();
                        return _context.finish(13);

                    case 17:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[4, 10, 13, 17]]);
    }));

    return function limitConcurrency(_x) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * Global store for tracking group summary, members, invited members and rooms.
 */


var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _groups = require('../groups');

var _FlairStore = require('./FlairStore');

var _FlairStore2 = _interopRequireDefault(_FlairStore);

var _MatrixClientPeg = require('../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2017 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

function parseMembersResponse(response) {
    return response.chunk.map(function (apiMember) {
        return (0, _groups.groupMemberFromApiObject)(apiMember);
    });
}

function parseRoomsResponse(response) {
    return response.chunk.map(function (apiRoom) {
        return (0, _groups.groupRoomFromApiObject)(apiRoom);
    });
}

// The number of ongoing group requests
var ongoingRequestCount = 0;

// This has arbitrarily been set to a small number to lower the priority
// of doing group-related requests because we care about other important
// requests like hitting /sync.
var LIMIT = 3; // Maximum number of ongoing group requests

// FIFO queue of functions to call in the backlog
var backlogQueue = [
    // () => {...}
];

// Pull from the FIFO queue
function checkBacklog() {
    var item = backlogQueue.shift();
    if (typeof item === 'function') item();
}
var GroupStore = function (_EventEmitter) {
    (0, _inherits3.default)(GroupStore, _EventEmitter);

    function GroupStore() {
        var _this$_fetchResourceP, _this$_resourceFetche;

        (0, _classCallCheck3.default)(this, GroupStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GroupStore.__proto__ || (0, _getPrototypeOf2.default)(GroupStore)).call(this));

        _this.STATE_KEY = {
            GroupMembers: 'GroupMembers',
            GroupInvitedMembers: 'GroupInvitedMembers',
            Summary: 'Summary',
            GroupRooms: 'GroupRooms'
        };

        _this._state = {};
        _this._state[_this.STATE_KEY.Summary] = {};
        _this._state[_this.STATE_KEY.GroupRooms] = {};
        _this._state[_this.STATE_KEY.GroupMembers] = {};
        _this._state[_this.STATE_KEY.GroupInvitedMembers] = {};

        _this._ready = {};
        _this._ready[_this.STATE_KEY.Summary] = {};
        _this._ready[_this.STATE_KEY.GroupRooms] = {};
        _this._ready[_this.STATE_KEY.GroupMembers] = {};
        _this._ready[_this.STATE_KEY.GroupInvitedMembers] = {};

        _this._fetchResourcePromise = (_this$_fetchResourceP = {}, (0, _defineProperty3.default)(_this$_fetchResourceP, _this.STATE_KEY.Summary, {}), (0, _defineProperty3.default)(_this$_fetchResourceP, _this.STATE_KEY.GroupRooms, {}), (0, _defineProperty3.default)(_this$_fetchResourceP, _this.STATE_KEY.GroupMembers, {}), (0, _defineProperty3.default)(_this$_fetchResourceP, _this.STATE_KEY.GroupInvitedMembers, {}), _this$_fetchResourceP);

        _this._resourceFetcher = (_this$_resourceFetche = {}, (0, _defineProperty3.default)(_this$_resourceFetche, _this.STATE_KEY.Summary, function (groupId) {
            return limitConcurrency(function () {
                return _MatrixClientPeg2.default.get().getGroupSummary(groupId);
            });
        }), (0, _defineProperty3.default)(_this$_resourceFetche, _this.STATE_KEY.GroupRooms, function (groupId) {
            return limitConcurrency(function () {
                return _MatrixClientPeg2.default.get().getGroupRooms(groupId).then(parseRoomsResponse);
            });
        }), (0, _defineProperty3.default)(_this$_resourceFetche, _this.STATE_KEY.GroupMembers, function (groupId) {
            return limitConcurrency(function () {
                return _MatrixClientPeg2.default.get().getGroupUsers(groupId).then(parseMembersResponse);
            });
        }), (0, _defineProperty3.default)(_this$_resourceFetche, _this.STATE_KEY.GroupInvitedMembers, function (groupId) {
            return limitConcurrency(function () {
                return _MatrixClientPeg2.default.get().getGroupInvitedUsers(groupId).then(parseMembersResponse);
            });
        }), _this$_resourceFetche);
        return _this;
    }

    (0, _createClass3.default)(GroupStore, [{
        key: '_fetchResource',
        value: function _fetchResource(stateKey, groupId) {
            var _this2 = this;

            // Ongoing request, ignore
            if (this._fetchResourcePromise[stateKey][groupId]) return;

            var clientPromise = this._resourceFetcher[stateKey](groupId);

            // Indicate ongoing request
            this._fetchResourcePromise[stateKey][groupId] = clientPromise;

            clientPromise.then(function (result) {
                _this2._state[stateKey][groupId] = result;
                _this2._ready[stateKey][groupId] = true;
                _this2._notifyListeners();
            }).catch(function (err) {
                // Invited users not visible to non-members
                if (stateKey === _this2.STATE_KEY.GroupInvitedMembers && err.httpStatus === 403) {
                    return;
                }

                console.error('Failed to get resource ' + stateKey + ' for ' + groupId, err);
                _this2.emit('error', err, groupId, stateKey);
            }).finally(function () {
                // Indicate finished request, allow for future fetches
                delete _this2._fetchResourcePromise[stateKey][groupId];
            });

            return clientPromise;
        }
    }, {
        key: '_notifyListeners',
        value: function _notifyListeners() {
            this.emit('update');
        }

        /**
         * Register a listener to recieve updates from the store. This also
         * immediately triggers an update to send the current state of the
         * store (which could be the initial state).
         *
         * If a group ID is specified, this also causes a fetch of all data
         * of the specified group, which might cause 4 separate HTTP
         * requests, but only if said requests aren't already ongoing.
         *
         * @param {string?} groupId the ID of the group to fetch data for.
         *                          Optional.
         * @param {function} fn the function to call when the store updates.
         * @return {Object} tok a registration "token" with a single
         *                      property `unregister`, a function that can
         *                      be called to unregister the listener such
         *                      that it won't be called any more.
         */

    }, {
        key: 'registerListener',
        value: function registerListener(groupId, fn) {
            var _this3 = this;

            this.on('update', fn);
            // Call to set initial state (before fetching starts)
            this.emit('update');

            if (groupId) {
                this._fetchResource(this.STATE_KEY.Summary, groupId);
                this._fetchResource(this.STATE_KEY.GroupRooms, groupId);
                this._fetchResource(this.STATE_KEY.GroupMembers, groupId);
                this._fetchResource(this.STATE_KEY.GroupInvitedMembers, groupId);
            }

            // Similar to the Store of flux/utils, we return a "token" that
            // can be used to unregister the listener.
            return {
                unregister: function unregister() {
                    _this3.unregisterListener(fn);
                }
            };
        }
    }, {
        key: 'unregisterListener',
        value: function unregisterListener(fn) {
            this.removeListener('update', fn);
        }
    }, {
        key: 'isStateReady',
        value: function isStateReady(groupId, id) {
            return this._ready[id][groupId];
        }
    }, {
        key: 'getGroupIdsForRoomId',
        value: function getGroupIdsForRoomId(roomId) {
            var _this4 = this;

            var groupIds = (0, _keys2.default)(this._state[this.STATE_KEY.GroupRooms]);
            return groupIds.filter(function (groupId) {
                var rooms = _this4._state[_this4.STATE_KEY.GroupRooms][groupId] || [];
                return rooms.some(function (room) {
                    return room.roomId === roomId;
                });
            });
        }
    }, {
        key: 'getSummary',
        value: function getSummary(groupId) {
            return this._state[this.STATE_KEY.Summary][groupId] || {};
        }
    }, {
        key: 'getGroupRooms',
        value: function getGroupRooms(groupId) {
            return this._state[this.STATE_KEY.GroupRooms][groupId] || [];
        }
    }, {
        key: 'getGroupMembers',
        value: function getGroupMembers(groupId) {
            return this._state[this.STATE_KEY.GroupMembers][groupId] || [];
        }
    }, {
        key: 'getGroupInvitedMembers',
        value: function getGroupInvitedMembers(groupId) {
            return this._state[this.STATE_KEY.GroupInvitedMembers][groupId] || [];
        }
    }, {
        key: 'getGroupPublicity',
        value: function getGroupPublicity(groupId) {
            return (this._state[this.STATE_KEY.Summary][groupId] || {}).user ? (this._state[this.STATE_KEY.Summary][groupId] || {}).user.is_publicised : null;
        }
    }, {
        key: 'isUserPrivileged',
        value: function isUserPrivileged(groupId) {
            return (this._state[this.STATE_KEY.Summary][groupId] || {}).user ? (this._state[this.STATE_KEY.Summary][groupId] || {}).user.is_privileged : null;
        }
    }, {
        key: 'refreshGroupRooms',
        value: function refreshGroupRooms(groupId) {
            return this._fetchResource(this.STATE_KEY.GroupRooms, groupId);
        }
    }, {
        key: 'refreshGroupMembers',
        value: function refreshGroupMembers(groupId) {
            return this._fetchResource(this.STATE_KEY.GroupMembers, groupId);
        }
    }, {
        key: 'addRoomToGroup',
        value: function addRoomToGroup(groupId, roomId, isPublic) {
            return _MatrixClientPeg2.default.get().addRoomToGroup(groupId, roomId, isPublic).then(this._fetchResource.bind(this, this.STATE_KEY.GroupRooms, groupId));
        }
    }, {
        key: 'updateGroupRoomVisibility',
        value: function updateGroupRoomVisibility(groupId, roomId, isPublic) {
            return _MatrixClientPeg2.default.get().updateGroupRoomVisibility(groupId, roomId, isPublic).then(this._fetchResource.bind(this, this.STATE_KEY.GroupRooms, groupId));
        }
    }, {
        key: 'removeRoomFromGroup',
        value: function removeRoomFromGroup(groupId, roomId) {
            return _MatrixClientPeg2.default.get().removeRoomFromGroup(groupId, roomId)
            // Room might be in the summary, refresh just in case
            .then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId)).then(this._fetchResource.bind(this, this.STATE_KEY.GroupRooms, groupId));
        }
    }, {
        key: 'inviteUserToGroup',
        value: function inviteUserToGroup(groupId, userId) {
            return _MatrixClientPeg2.default.get().inviteUserToGroup(groupId, userId).then(this._fetchResource.bind(this, this.STATE_KEY.GroupInvitedMembers, groupId));
        }
    }, {
        key: 'acceptGroupInvite',
        value: function acceptGroupInvite(groupId) {
            return _MatrixClientPeg2.default.get().acceptGroupInvite(groupId)
            // The user should now be able to access (personal) group settings
            .then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId))
            // The user might be able to see more rooms now
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupRooms, groupId))
            // The user should now appear as a member
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupMembers, groupId))
            // The user should now not appear as an invited member
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupInvitedMembers, groupId));
        }
    }, {
        key: 'joinGroup',
        value: function joinGroup(groupId) {
            return _MatrixClientPeg2.default.get().joinGroup(groupId)
            // The user should now be able to access (personal) group settings
            .then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId))
            // The user might be able to see more rooms now
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupRooms, groupId))
            // The user should now appear as a member
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupMembers, groupId))
            // The user should now not appear as an invited member
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupInvitedMembers, groupId));
        }
    }, {
        key: 'leaveGroup',
        value: function leaveGroup(groupId) {
            return _MatrixClientPeg2.default.get().leaveGroup(groupId)
            // The user should now not be able to access group settings
            .then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId))
            // The user might only be able to see a subset of rooms now
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupRooms, groupId))
            // The user should now not appear as a member
            .then(this._fetchResource.bind(this, this.STATE_KEY.GroupMembers, groupId));
        }
    }, {
        key: 'addRoomToGroupSummary',
        value: function addRoomToGroupSummary(groupId, roomId, categoryId) {
            return _MatrixClientPeg2.default.get().addRoomToGroupSummary(groupId, roomId, categoryId).then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId));
        }
    }, {
        key: 'addUserToGroupSummary',
        value: function addUserToGroupSummary(groupId, userId, roleId) {
            return _MatrixClientPeg2.default.get().addUserToGroupSummary(groupId, userId, roleId).then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId));
        }
    }, {
        key: 'removeRoomFromGroupSummary',
        value: function removeRoomFromGroupSummary(groupId, roomId) {
            return _MatrixClientPeg2.default.get().removeRoomFromGroupSummary(groupId, roomId).then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId));
        }
    }, {
        key: 'removeUserFromGroupSummary',
        value: function removeUserFromGroupSummary(groupId, userId) {
            return _MatrixClientPeg2.default.get().removeUserFromGroupSummary(groupId, userId).then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId));
        }
    }, {
        key: 'setGroupPublicity',
        value: function setGroupPublicity(groupId, isPublished) {
            return _MatrixClientPeg2.default.get().setGroupPublicity(groupId, isPublished).then(function () {
                _FlairStore2.default.invalidatePublicisedGroups(_MatrixClientPeg2.default.get().credentials.userId);
            }).then(this._fetchResource.bind(this, this.STATE_KEY.Summary, groupId));
        }
    }]);
    return GroupStore;
}(_events2.default);

var singletonGroupStore = null;
if (!singletonGroupStore) {
    singletonGroupStore = new GroupStore();
}
module.exports = singletonGroupStore;
//# sourceMappingURL=GroupStore.js.map